import { render, staticRenderFns } from "./imageGallery.vue?vue&type=template&id=13aa5f1e&scoped=true&"
import script from "./imageGallery.vue?vue&type=script&lang=js&"
export * from "./imageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa5f1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
